import * as React from 'react'

import { CustomTimeRangeCategoriesCollection } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'
import { CustomTimeRangesCollection } from 'modules/attendance/hooks/useFetchCustomTimeRanges'
import { CustomTimeRangeCategoriesCollection as TimeSettingsCustomTimeRangeCategoriesCollection } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import BlankSlate from './BlankSlate'
import CustomTimeRangesTable from './Table'
import TimeCategoriesValues from './TimeCategoriesValues'

interface Props {
  settingId: string
  timeSettingsCategories: TimeSettingsCustomTimeRangeCategoriesCollection
  timeRangeCategories: CustomTimeRangeCategoriesCollection
  customTimeRanges: CustomTimeRangesCollection
}

const CustomTimeRangesContent = ({
  settingId,
  timeSettingsCategories,
  timeRangeCategories,
  customTimeRanges,
}: Props) => {
  const { hasTimeSettingsCategories, hasActiveCategories } = timeSettingsCategories

  // There are no categories
  if (!hasTimeSettingsCategories) {
    return <BlankSlate />
  }

  const { hasTimeRangeCategories } = timeRangeCategories
  const { hasCustomTimeRanges } = customTimeRanges

  // There are only archived categories and no Time blocks or Work time category values already created
  if (!hasActiveCategories && (!hasCustomTimeRanges || !hasTimeRangeCategories)) {
    return <BlankSlate />
  }

  const categoriesWithTimeSettingCategoryActive = timeRangeCategories.withTimeSettingCategoryActive
  const hasActiveCustomTimeRangeCategories = categoriesWithTimeSettingCategoryActive.length > 0
  const showTable = hasActiveCustomTimeRangeCategories || hasCustomTimeRanges

  return (
    <>
      <TimeCategoriesValues settingId={settingId} />
      {showTable && <CustomTimeRangesTable settingId={settingId} />}
    </>
  )
}

export default CustomTimeRangesContent
